// Simple client-side "supporter" flag.
// Honor system: the user claims they tipped, we hide ads on their device.
// Stored in localStorage so it survives reloads. Cleared on demand.

const KEY = "vault.supporter";

export function readTipper() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.claimed_at) return null;
    return data;
  } catch {
    return null;
  }
}

export function saveTipper(payload = {}) {
  const data = {
    claimed_at: new Date().toISOString(),
    name: (payload.name || "").trim().slice(0, 60),
    note: (payload.note || "").trim().slice(0, 240),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* storage disabled */
  }
  window.dispatchEvent(new Event("vault:tipper-changed"));
  return data;
}

export function clearTipper() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event("vault:tipper-changed"));
}
